import { WriterHeaderProps } from './Types'
import { ArticleView } from 'types'
import { CanView } from 'components/Can'
import { observer } from 'mobx-react-lite'
import { WriterTopBar } from '../WriterTopBar/WriterTopBar'
import { WriterToolbar } from 'components/WriterToolbar/WriterToolbar'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MobileWriterHeader } from 'blaze-components/WorkspaceDashboardHeader/MobileWriterHeader'
import { Header } from './Header'

const WriterHeader = observer(({ workspace }: WriterHeaderProps) => {
  return (
    <Header data-testid="writer-header">
      <WriterTopBar />
      <CanView inWorkspace={workspace.id} inViewMode={ArticleView.Editing}>
        <WriterToolbar />
      </CanView>
    </Header>
  )
})

const WriterHeaderContainer = (props: WriterHeaderProps) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobileWriterHeader {...props} /> : <WriterHeader {...props} />
}

export { WriterHeaderContainer as WriterHeader }
